import { useId } from "react";
import { hostThemeMarkStops, normalizeHostTheme } from "../lib/hostThemes";

const SIZES = {
  sm: "w-8 h-8",
  md: "w-9 h-9",
};

/** App icon — gradient tile with white music note (matches favicon.svg). */
export default function BrandMark({ size = "md", className = "", themeId }) {
  const gradientId = `brand-cta-${useId().replace(/:/g, "")}`;
  const [c0, c1, c2] = hostThemeMarkStops(normalizeHostTheme(themeId));

  return (
    <svg
      className={`shrink-0 ${SIZES[size] || SIZES.md} ${className}`}
      viewBox="0 0 32 32"
      role="img"
      aria-hidden
    >
      <defs>
        <linearGradient id={gradientId} x1="0.085" y1="0.22" x2="0.915" y2="0.78">
          <stop offset="0%" stopColor={c0} />
          <stop offset="45%" stopColor={c1} />
          <stop offset="100%" stopColor={c2} />
        </linearGradient>
      </defs>
      <rect width="32" height="32" rx="8" fill={`url(#${gradientId})`} />
      <g
        transform="translate(4 4)"
        fill="none"
        stroke="#ffffff"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <circle cx="8" cy="18" r="4" />
        <path d="M12 18V2l7 4" />
      </g>
    </svg>
  );
}
